module.exports = __webpack_public_path__ + "img/btn-day.51c49723.png";